import React, { useEffect, useState, createElement } from 'react';
import { CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
import { Footer } from './Footer';
import { FacebookPixel } from './FacebookPixel';
export function ThankYouPage() {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoExamples = [{
    id: 'sidiz5rkoc',
    title: 'Ejemplo 1'
  }, {
    id: 'h4scddj950',
    title: 'Ejemplo 2'
  }];
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  }, []);
  useEffect(() => {
    // Load Wistia player scripts for main video
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/a72y8tn9om.js';
    script2.async = true;
    script2.type = 'module';
    document.head.appendChild(script2);
    // Load scripts for carousel videos
    const script3 = document.createElement('script');
    script3.src = 'https://fast.wistia.com/embed/sidiz5rkoc.js';
    script3.async = true;
    script3.type = 'module';
    document.head.appendChild(script3);
    const script4 = document.createElement('script');
    script4.src = 'https://fast.wistia.com/embed/h4scddj950.js';
    script4.async = true;
    script4.type = 'module';
    document.head.appendChild(script4);
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
      document.head.removeChild(script4);
    };
  }, []);
  const nextVideo = () => {
    setCurrentVideoIndex(prev => (prev + 1) % videoExamples.length);
  };
  const prevVideo = () => {
    setCurrentVideoIndex(prev => (prev - 1 + videoExamples.length) % videoExamples.length);
  };
  return <div className="min-h-screen w-full bg-gradient-to-b from-gray-900 to-black text-white flex flex-col" data-id="element-651">
      <FacebookPixel pixelId="754551913878347" data-id="element-652" />
      <style dangerouslySetInnerHTML={{
      __html: `
          wistia-player[media-id='a72y8tn9om']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/a72y8tn9om/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:56.25%; 
          }
          wistia-player[media-id='sidiz5rkoc']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/sidiz5rkoc/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
          wistia-player[media-id='h4scddj950']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/h4scddj950/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:177.78%; 
          }
          .brush-highlight {
            position: relative;
            display: inline-block;
            z-index: 1;
          }
          .brush-highlight::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: -4px;
            right: -4px;
            height: 12px;
            background: linear-gradient(to right, 
              rgba(239, 68, 68, 0.7) 0%, 
              rgba(239, 68, 68, 0.8) 25%, 
              rgba(239, 68, 68, 0.9) 50%, 
              rgba(239, 68, 68, 0.8) 75%, 
              rgba(239, 68, 68, 0.7) 100%
            );
            border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
            transform: rotate(-1deg);
            z-index: -1;
            filter: blur(1px);
          }
        `
    }} data-id="element-653" />
      <header className="fixed top-0 left-0 right-0 z-40 w-full px-4 py-2 bg-gray-900 bg-opacity-80 backdrop-blur-lg border-b border-gray-800 h-[88px]" data-id="element-654">
        <div className="flex flex-col items-center justify-center h-full gap-0.5" data-id="element-655">
          <div className="w-full max-w-[600px] h-[40px] flex items-center justify-center px-4" data-id="element-656">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gqSiWiuARq6wcs7g3ZrS3R/TRUSTED_BADGE.png" alt="Trusted by 1000+ Verified Customers" className="w-full h-auto max-h-[40px] object-contain" data-id="element-657" />
          </div>
          <div className="w-[100px] h-[28px] flex items-center justify-center" data-id="element-658">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nsoAdMCr2MakXFCqq5bSP/gb_signature.png" alt="Signature" className="w-full h-auto max-w-[100px]" width="100" height="28" data-id="element-659" />
          </div>
        </div>
      </header>
      <div className="flex-grow flex items-center justify-center p-4 md:p-8 pt-[112px]" data-id="element-660">
        <div className="max-w-5xl w-full py-8 md:py-12 lg:py-16" data-id="element-661">
          <div className="text-center mb-8 md:mb-12 lg:mb-16 px-4" data-id="element-662">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 leading-tight" data-id="element-663">
              ¡Felicidades! Tu Lugar Está Reservado
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-gray-400 leading-relaxed" data-id="element-664">
              Te hemos enviado un email de confirmación con todos los detalles.
            </p>
          </div>
          <div className="bg-gray-800 bg-opacity-50 rounded-xl md:rounded-2xl p-6 md:p-8 lg:p-12 mb-8 md:mb-12 lg:mb-16" data-id="element-665">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 md:mb-8 lg:mb-10 text-center leading-tight px-4" data-id="element-666">
              Mira Este Video Para Obtener Acceso A La masterclass.
            </h2>
            <div className="aspect-video bg-black overflow-hidden max-w-4xl mx-auto shadow-2xl rounded-lg md:rounded-xl" data-id="element-667">
              <wistia-player media-id="a72y8tn9om" aspect="1.7777777777777777" data-id="element-668"></wistia-player>
            </div>
            <div className="flex justify-center mt-6 md:mt-8 px-4" data-id="element-669">
              <a href="https://chat.whatsapp.com/DBtAvtgTtmUERL12dsdcm2" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-green-600 hover:bg-green-700 active:bg-green-800 text-white text-base sm:text-lg md:text-xl lg:text-2xl font-bold py-4 md:py-5 px-8 md:px-12 shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-300 touch-manipulation w-full md:w-auto justify-center" data-id="element-670">
                <svg className="h-6 w-6 md:h-7 md:w-7 mr-2 md:mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-671">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-672" />
                </svg>
                <span className="text-center" data-id="element-673">Unirse al Grupo de WhatsApp</span>
              </a>
            </div>
            <div className="mt-8 md:mt-12 px-4" data-id="element-674">
              <div className="flex justify-center mb-4" data-id="element-675"></div>
            </div>
            <div className="text-center mt-4 md:mt-6 px-4" data-id="element-676">
              <p className="text-base md:text-lg text-yellow-400 leading-relaxed" data-id="element-677">
                Tu <span className="font-bold" data-id="element-678">REGALO GRATIS:</span> Guía
                completa de implementación paso a paso para seguir lo que
                enseñaré en la masterclass en vivo de Info Commerce AI.
              </p>
            </div>
          </div>
          
          <div className="text-center px-4" data-id="element-679">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-6 md:mb-8 lg:mb-10" data-id="element-680">
              Únete a nuestro grupo de WhatsApp
            </h3>
            <div className="text-left max-w-3xl mx-auto mb-8 md:mb-10 lg:mb-12" data-id="element-681">
              <p className="text-gray-300 mb-8 md:mb-10 text-base sm:text-lg md:text-xl leading-relaxed" data-id="element-682">
                Para recibir el enlace de acceso directo a la masterclass y
                recordatorios importantes, necesitas unirte a nuestro grupo
                exclusivo de WhatsApp.
              </p>
              <h4 className="text-lg sm:text-xl md:text-2xl font-semibold text-white mb-6 md:mb-8" data-id="element-683">
                ¿Por qué WhatsApp?
              </h4>
              <ul className="space-y-4 md:space-y-6 mb-8 md:mb-10" data-id="element-684">
                <li className="flex items-start" data-id="element-685">
                  <CheckCircleIcon className="h-5 w-5 md:h-6 md:w-6 text-green-500 mr-3 md:mr-4 flex-shrink-0 mt-1" data-id="element-686" />
                  <span className="text-gray-300 text-base sm:text-lg md:text-xl leading-relaxed" data-id="element-687">
                    Recibirás el enlace de acceso 30 minutos antes
                  </span>
                </li>
                <li className="flex items-start" data-id="element-688">
                  <CheckCircleIcon className="h-5 w-5 md:h-6 md:w-6 text-green-500 mr-3 md:mr-4 flex-shrink-0 mt-1" data-id="element-689" />
                  <span className="text-gray-300 text-base sm:text-lg md:text-xl leading-relaxed" data-id="element-690">
                    Te enviaremos recordatorios para que no te lo pierdas
                  </span>
                </li>
                <li className="flex items-start" data-id="element-691">
                  <CheckCircleIcon className="h-5 w-5 md:h-6 md:w-6 text-green-500 mr-3 md:mr-4 flex-shrink-0 mt-1" data-id="element-692" />
                  <span className="text-gray-300 text-base sm:text-lg md:text-xl leading-relaxed" data-id="element-693">
                    Acceso a material exclusivo solo para participantes
                  </span>
                </li>
              </ul>
              <div className="bg-yellow-900 bg-opacity-30 border-2 border-yellow-600 rounded-lg md:rounded-xl p-4 md:p-6 lg:p-8 mb-8 md:mb-10" data-id="element-694">
                <div className="flex items-start" data-id="element-695">
                  <AlertCircleIcon className="h-6 w-6 md:h-7 md:w-7 text-yellow-500 mr-3 md:mr-4 flex-shrink-0 mt-1" data-id="element-696" />
                  <div data-id="element-697">
                    <p className="font-semibold text-yellow-300 mb-2 md:mb-3 text-base sm:text-lg md:text-xl" data-id="element-698">
                      IMPORTANTE:
                    </p>
                    <p className="text-gray-300 text-base sm:text-lg md:text-xl leading-relaxed" data-id="element-699">
                      Si no te unes al grupo, no podrás acceder a la masterclass
                      en vivo.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer data-id="element-700" />
    </div>;
}